"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var react_highlight_words_1 = tslib_1.__importDefault(require("react-highlight-words"));
var clsx_1 = tslib_1.__importDefault(require("clsx"));
var SelectableTreeItem = function (_a) {
    var ID = _a.ID, name = _a.name, setValue = _a.setValue, value = _a.value, setIsSearching = _a.setIsSearching, setSelectedItemID = _a.setSelectedItemID, selectedItemID = _a.selectedItemID;
    var _b = react_1.useState(false), isSelected = _b[0], setIsSelected = _b[1];
    var selectItem = react_1.useCallback(function (e) {
        var _a, _b;
        var item = e.target;
        var closestLi = item.closest('li');
        (_a = document.querySelector('li.selected')) === null || _a === void 0 ? void 0 : _a.classList.remove('selected');
        closestLi === null || closestLi === void 0 ? void 0 : closestLi.classList.add('selected');
        setIsSelected(true);
        setValue(name);
        setSelectedItemID(ID);
        (_b = document.getElementById('tree-select')) === null || _b === void 0 ? void 0 : _b.blur();
        setIsSearching(false);
    }, []);
    react_1.useEffect(function () {
        if (value === name && selectedItemID === ID) {
            setIsSelected(true);
        }
        else {
            setIsSelected(false);
        }
    }, [value, selectedItemID]);
    return (react_1.default.createElement("div", { role: "button", "data-testid": "button-" + ID, onClick: selectItem, onKeyDown: selectItem, tabIndex: 0 },
        react_1.default.createElement("li", { "data-value": ID, "data-testid": "selectable-item-" + ID, className: clsx_1.default({ selected: isSelected }) },
            react_1.default.createElement(CheckIcon, { isSelected: isSelected, className: "icon--check" }),
            !selectedItemID ? (react_1.default.createElement(react_highlight_words_1.default, { searchWords: [value], textToHighlight: name, className: "highlighted_tree_item", highlightClassName: "option_highlighted_text", "data-testid": "highlighted_tree_item" })) : (react_1.default.createElement("span", null, name)))));
};
exports.default = SelectableTreeItem;
var CheckIcon = styled_components_1.default.i(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  visibility: ", ";\n  font-size: 1.4rem;\n  color: ", ";\n  padding-right: 0.8rem;\n"], ["\n  visibility: ", ";\n  font-size: 1.4rem;\n  color: ", ";\n  padding-right: 0.8rem;\n"])), function (p) { return (p.isSelected ? 'visible' : 'hidden'); }, function (_a) {
    var theme = _a.theme;
    return theme.colors.aqua[500];
});
var templateObject_1;
